/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'logout': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M21.616 24.293l-5.232 4.359c-.211.176-.384.096-.384-.179V26h-5.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5H16v-2.473c0-.275.174-.356.386-.182l5.229 4.309a.402.402 0 0 1 .001.639zM36 14v18a.973.973 0 0 1-.072.358c-.015.038-.037.069-.057.106a.918.918 0 0 1-.131.194c-.03.035-.063.063-.098.093a.953.953 0 0 1-.184.123c-.042.022-.082.043-.127.06-.024.008-.044.024-.069.031l-11 3a1.008 1.008 0 0 1-.869-.17A1 1 0 0 1 23 35v-2h-4a1 1 0 0 1-1-1v-2.611l5-4.167v-2.498l-5-4.122V14a1 1 0 0 1 1-1h16c.039 0 .071.018.109.021.056.007.107.018.161.033.09.025.17.062.247.11.028.018.063.02.09.04.016.012.022.032.037.046a.963.963 0 0 1 .191.23c.021.035.05.064.067.101.06.129.098.269.098.419zm-2 1.31l-9 2.454V33.69l9-2.454V15.31z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/logout.js